



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Navi extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly prev!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly next!: boolean;

  @Prop({ type: String, default: '' })
  readonly month!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/navi/Navi.vue